import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { puroClientsFrag } from './types/puro.gql-types';
import { PuroGridObject } from '@libs/types/src/services/object-type/statistics/puro-stats.object';
import { filterFrag } from '../modules/content/service/types/filter.types';
import { GridInput } from '@it2go/data-grid';
import { PmupStatsInput } from '@libs/types/src/services/input-type/statistics/pmup-stats.input';
import {
    PmupBonifiedClients,
    PmupStatsObject,
    PmupUnlimitedPayments,
} from '@libs/types/src/services/object-type/statistics/pmup-stats.object';

@Injectable({ providedIn: 'root' })
export class PmupGqlService extends GqlServiceV2 {

    public async getPmupStatistics(input: PmupStatsInput, fragment: string) {
        return this.query<PmupStatsObject[]>(
            `
                query($input: PmupStatsInput!) {
                    pmup {
                        pmupStats(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getPmupBonifiedClients(input: PmupStatsInput, fragment: string) {
        return this.query<PmupBonifiedClients>(
            `
                query($input: PmupStatsInput!) {
                    pmup {
                        bonifiedClients(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getPmupClients(input: GridInput, fragment: string = puroClientsFrag) {
        return this.query<PuroGridObject>(
            `
                query($input: GridInput!) {
                    pmup {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getPmupUnlimitedPayments(input: PmupStatsInput, fragment: string) {
        return this.query<PmupUnlimitedPayments>(
            `
                query($input: PmupStatsInput!) {
                    pmup {
                        unlimitedPayments(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
